/**
 * 商品相关接口
 */
const url = '/checkmall-goods/api'
export default {
    // 获取产品树、商品分类
    catType: url + "/goods/tree",
    // LIMS 产品树
    limsCatType: url + "/goods/limisTree",
    // 用户查询商品列表
    list: url + "/goods/list",
    // 用户通过商品prn查询商品信息
    goodsByPrn: url + "/goods/goodsByPrn",
    // 样品列表
    getGoodsNameList: url + "/web/goods/getGoodsNameList",
    // 服务详情-项目列表,根据产品树获取检项
    getPrjByProd: url + '/project/list',
    // 服务详情-项目列表,根据产品树获取检项
    getLimsPrjByProd: url + '/project/limisList'
}